import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const SectionTitle = styled(Typography)({
  color: 'black',
  fontWeight: '500'
}); 